// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"e751df83","145":"d49d04e6"}[chunkId] + ".chunk.css";
};